import React from "react"
import { UserSquareIcon } from "@assets/icons"
import { useSelector } from "react-redux"

const PatientHeader = () => {
  const { patient } = useSelector((state) => state.patient)
  const profileDetails = patient?.data[0]
  const patientName = `${profileDetails?.local?.firstName || ""} ${profileDetails?.local?.lastName || ""}`
  return (
    <div className="gap-2 flex items-center mx-4 md:mx-0">
      <UserSquareIcon className="h-6 w-6 text-[var(--text-theme)]" />
      <div className="text-xs text-[--text-light-gray] font-bold tracking-widest">
        {patientName}
      </div>
    </div>
  )
}

export default PatientHeader
